import { CatalogProduct, CatalogProductInput, CatalogProductQuery } from '../types'
import createAPIClient from '../services/apiClient'
import { AxiosRequestConfig } from 'axios'

const api = createAPIClient('/v2')

export async function getCatalogProducts(
  query: CatalogProductQuery = {},
  config?: Omit<AxiosRequestConfig, 'params'>
): Promise<CatalogProduct[]> {
  const response = await api.get('/catalog-products', {
    params: query,
    ...config
  })

  return response.data
}

export async function getCatalogProduct(
  id: string,
  config?: AxiosRequestConfig
): Promise<CatalogProduct> {
  const response = await api.get(`/catalog-products/${id}`, config)

  return response.data
}

export async function createCatalogProduct(
  input: CatalogProductInput,
  config?: AxiosRequestConfig
): Promise<CatalogProduct> {
  const response = await api.post('/catalog-products', input, config)

  return response.data
}

export async function uploadCatalogProductPhoto(
  id: string,
  photo: File,
  { headers, ...config }: AxiosRequestConfig = {}
) {
  const formData = new FormData()

  formData.append('file', photo)
  const response = await api.patch(`/catalog-products/${id}/photo`, formData, {
    ...config,
    headers: {
      ...headers,
      'Content-Type': 'multipart/form-data'
    }
  })

  return response.data
}

export async function updateCatalogProduct(
  id: string,
  input: Partial<CatalogProductInput>,
  config?: AxiosRequestConfig
): Promise<CatalogProduct> {
  const response = await api.put(`/catalog-products/${id}`, input, config)

  return response.data
}

export async function deleteCatalogProduct(id: string, config?: AxiosRequestConfig): Promise<void> {
  await api.delete(`/catalog-products/${id}`, config)
}

export default {
  getCatalogProducts,
  getCatalogProduct,
  createCatalogProduct,
  uploadCatalogProductPhoto,
  updateCatalogProduct,
  deleteCatalogProduct
}
